export const environment = {
    production: true,
    apiUrl: 'https://stampelklockan-qa-appsvc-01.azurewebsites.net/api',
    versionUrl: 'https://qa.stampelklockan.nu/version.json'
};
